export default {
  pageNavbar: [
    {
      name: "Bezpieczeństwo",
      anchor: "safety"
    },
    {
      name: "FCM",
      anchor: "FCM"
    },
    {
      name: "ACC",
      anchor: "ACC"
    },
    {
      name: "LDW",
      anchor: "LDW"
    },
    {
      name: "RCTA",
      anchor: "RCTA"
    },
    {
      name: "AHB",
      anchor: "AHB"
    },
    {
      name: "Więcej",
      anchor: "more"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  headerDesc:
    "Zaawansowane systemy bezpieczeństwa pomagają pewniej poruszać się po drogach i na parkingach - zarówno w dzień, jak i w nocy. Eclipse Cross PHEV zapewnia wysoki poziom bezpieczeństwa pod każdym względem - począwszy od inteligentnych czujników, które monitorują otoczenie i ostrzegają o niebezpieczeństwie, po aktywne systemy wspomagające kierowcę i solidne wyposażenie z zakresu biernej ochrony.",
  headerButton: "Zobacz wideo",
  safetyRoadHeader: "Dla bezpieczeństwa na drodze",
  safetyRoadSubHeader: "System ograniczający skutki kolizji czołowych (FCM)",
  safetyRoadDesc:
    "Zadaniem systemu jest niedopuszczenie do kolizji polegajacej na najechaniu na inny pojazd lub przeszkodę, lub przynajmniej ograniczenie skutków kolizji, gdy jest ona nieunikniona. Za pomocą kamery i radaru laserowego systemu wykrywania inne pojazdy oraz pieszych przed samochodem.",
  safetyAllHeader: "Dla bezpieczeństwa wszystkich",
  safetyAllSubHeader: "Tempomat adaptacyjny (ACC)",
  safetyAllDesc:
    "Samochód utrzymuje zadaną odległość od pojazdu poprzedzającego na podstawie wskazań radaru, co poprawia bezpieczeństwo jazdy i zwiększa poczucie spokoju. System ogranicza stres kierowcy, zwłaszcza w czasie długotrwałej jazdy przy intensywnym ruchu na autostradzie.",
  ldwSubHeader: "Zaawansowana technologia",
  ldwHeader: "System ostrzegający o niezamierzonej zmianie pasa ruchu [LDW]",
  ldwDesc:
    "System ostrzega brzęczykiem i wyświetla odpowiedni komunikat w przypadku wykrycia, że samochód opuszcza pas ruchu bez włączonego kierunkowskazu.",
  ldwButton: "Zobacz wideo",
  textWitVideoSubHeader: "Zaawansowana technologia",
  textWitVideoHeader: "RCTA",
  textWitVideoHeaderSecond:
    "System monitorowania ruchu poprzecznego podczas jazdy do tyłu (RCTA)",
  textWitVideoDesc:
    "Kiedy system RCTA jest aktywny, w zestawie wskaźników widoczna jest kontrola. Jeżeli przy włączonym wstecznym biegu czujniki radarowe w tylnym zderzaku wykryją zbliżający się pojazd w niewielkiej odległości, na wyświetlaczu wielofunkcyjnym pojawi się komunikat ostrzegawczy, włączy się brzęczyk, a w obu lusterkach bocznych będą migać kontrolki.",
  textWitVideoButton: "Zobacz wideo",
  ahbSubHeader: "Bezpiecznie nocą",
  ahbHeader: "Automatyczne światła drogowe (AHB)",
  ahbDesc:
    "W celu zwiększenia bezpieczeństwa i komfortu oraz ułatwienia prowadzenia samochodu nocą światła drogowe automatycznie przełączają się na światła mijania, kiedy system wykryje pojazd poprzedzający lub nadjeżdżający z przeciwka. Następnie światła drogowe znów włączają się automatycznie, więc nie trzeba zdejmować dłoni z kierownicy i używać ręcznego przełącznika.",
  advancedSubHeader: "Zaawansowane technologie",
  advancedHeader: "Więcej",
  advancedEasy:
    "System monitorowania martwego pola w lusterkach zewnętrznych (BSW)",
  advancedEasyDesc:
    "Ta funkcja zwiększająca bezpieczeństwo wykorzystuje czujniki radarowe w tylnym zderzaku w celu wykrywania pojazdów w martwych polach za samochodem, po jego prawej i lewej stronie. Kiedy system BSW jest aktywny, a kierunkowskazy są wyłączone, w lusterkach bocznych zapala się kontrolka. W przypadku wykrycia pojazdu w martwym polu przy włączonym kierunkowskazie kontrolka w lusterku z odpowiedniej strony miga i pojawia się powiadomienie dźwiękowe.",
  advancedMode: "Ultradźwiękowy asystent ruszania (UMS)",
  advancedModeDesc:
    "Zadaniem systemu UMS jest ograniczenie lub w niektórych sytuacjach uniknięcie kolizji parkingowych spowodowanych niezamierzonym wciśnięciem pedału przyspieszenia. Jeśli system wykryje taką sytuację moc silnika jest redukowana i pojazd nie przyspiesza.",
  advancedPower: "Konstrukcja Rise",
  advancedPowerDesc:
    "Bezpieczeństwo bierne zostało znacznie zwiększone dzięki zastosowaniu opracowanej przez Mitsubishi Motos wzmocnionej konstrukcji nadwozia RISE (Reinforced Impact Safety Evolution), która skuteczine pochłania energię i utrzymuje wnętrze kabiny w całości w razie kolizji.",
  advancedImages: ["advanced-image-first.jpg", "advanced-image-second.png"],
  footerSlider: [
    {
      header: "Wykrywanie pieszych",
      description:
        "FCM ogranicza ryzyko najechania na inny pojazd lub pieszego.",
      background: "WYKRYWANIE.png"
    },
    {
      header: "TEMPOMAT ADAPTACYJNY",
      description:
        "Samochód utrzymuje zadaną odległość od pojazdu poprzedzającego na podstawie wskazań radaru, co poprawia bezpieczeństwo jazdy i zwiększa poczucie spokoju.",
      background: "ZACHOWYWANIE.png"
    },
    {
      header: "SYSTEM MONITOROWANIA MARTWEGO POLA W LUSTERKACH ZEWNĘTRZNYCH",
      description:
        "Ta funkcja zwiększająca bezpieczeństwo wykorzystuje czujniki radarowe w tylnym zderzaku w celu wykrywania pojazdów w martwych polach za samochodem, po jego prawej i lewej stronie.",
      background: "martwe-pole.jpg"
    },
    {
      header: "ULTRADŹWIĘKOWY ASYSTENT RUSZANIA",
      description:
        "Zadaniem systemu UMS jest ograniczenie lub w niektórych sytuacjach uniknięcie kolizji parkingowych spowodowanych niezamierzonym wciśnięciem pedału przyspieszenia.",
      background: "asystent.png"
    }
  ]
};
